'use client'

import type { ComponentPropsWithoutRef, ReactNode } from 'react'
import { CaretDownIcon } from '@phosphor-icons/react/dist/ssr/CaretDown'
import { CaretRightIcon } from '@phosphor-icons/react/dist/ssr/CaretRight'

import { cn } from '@/utils/cn'

type CollapsiblePanelProps = Omit<
  ComponentPropsWithoutRef<'section'>,
  'children'
> & {
  children?: ReactNode
  contentClassName?: string
  onOpenChange: (open: boolean) => void
  open: boolean
  summary: ReactNode
  summaryClassName?: string
}

export const CollapsiblePanel = ({
  children,
  className,
  contentClassName,
  onOpenChange,
  open,
  summary,
  summaryClassName,
  ...sectionProps
}: CollapsiblePanelProps) => (
  <section
    {...sectionProps}
    className={cn(
      'overflow-hidden rounded-md border border-neutral-200 bg-white text-sm',
      className,
    )}
  >
    <button
      type="button"
      aria-expanded={open}
      className={cn(
        'flex w-full items-start justify-between gap-3 px-4 py-3 text-left',
        summaryClassName,
      )}
      onClick={() => onOpenChange(!open)}
    >
      <div className="min-w-0 flex-1">{summary}</div>
      <span className="mt-0.5 flex size-5 shrink-0 items-center justify-center text-neutral-500">
        {open ? (
          <CaretDownIcon className="size-4" />
        ) : (
          <CaretRightIcon className="size-4" />
        )}
      </span>
    </button>
    {open && children ? (
      <div
        className={cn(
          'border-t border-neutral-100 px-4 py-3',
          contentClassName,
        )}
      >
        {children}
      </div>
    ) : null}
  </section>
)
